import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from '../../../../../common/Select';
import { fetchGetEshopTypes } from '../../../../../../actions/admin';
import { VAT_RATES } from '../../../../../../config';
import {
  sortByRussianAndEnglishTitles,
  sortRussianThenEnglishByKey,
} from '../../../../../../helpers';

export const MarketplaceTypeSelect = React.memo(({ value, setFieldValue, errors, submitCount }) => {
  const marketplaceTypes = useSelector((state) => state.admin.eshopTypes);

  const marketplaceTypesOptions = useMemo(() => {
    return sortRussianThenEnglishByKey(marketplaceTypes, 'title').map((m) => {
      return {
        label: m.title,
        value: m.type,
      };
    });
  }, [marketplaceTypes]);

  return (
    <div className="col-12 mt-2">
      <Select
        id="type"
        label="Маркетплейс"
        error={errors.type}
        showValidation={submitCount}
        options={marketplaceTypesOptions}
        value={
          marketplaceTypesOptions?.find((o) => o.value === value) || { label: value, value: value }
        }
        onChange={({ value }) => setFieldValue('type', value)}
        isClearable={false}
      />
    </div>
  );
});

export const WarehouseNameSelect = React.memo(({ value, setFieldValue }) => {
  const warehouses = useSelector((state) => state.admin?.warehouses?.warehouses);

  const warehouseOptions = warehouses?.map((w) => {
    return {
      label: w.title,
      value: w.code,
    };
  });

  return (
    <div className="col-12 mt-2">
      <Select
        label="Склад"
        id="warehouse"
        options={warehouseOptions}
        value={warehouseOptions?.find((o) => o.value === value?.id)}
        onChange={(option) => {
          setFieldValue('warehouse', { ...value, id: option.value });
        }}
        isClearable={false}
      />
    </div>
  );
});

export const ProductPriceTypeSelect = React.memo(({ id, label, value, setFieldValue }) => {
  const priceTypes = useSelector((state) => state.admin?.eshopPriceType);

  const priceTypeOptions = priceTypes?.map((p) => {
    return {
      label: p.name,
      value: p.code,
    };
  });

  return (
    <div className="col-12 mt-2">
      <Select
        id={id}
        label={label}
        options={priceTypeOptions}
        value={priceTypeOptions?.find((o) => o.value === value)}
        onChange={(option) => {
          setFieldValue(id, option.value);
        }}
        isClearable={false}
      />
    </div>
  );
});

export const DeliveryContractSelect = React.memo(({ value, setFieldValue }) => {
  const deliveryInfoList = useSelector((state) => state.admin?.deliveryInfo?.deliveryInfoList);

  const deliveryInfoOptions = useMemo(
    () =>
      deliveryInfoList
        ?.filter((item) => item.active)
        ?.map(({ title, code }) => ({
          label: title,
          value: code,
        })),
    [deliveryInfoList],
  );

  return (
    <div className="col-12 mt-2">
      <Select
        id="deliveryInfo"
        label="Договор доставки"
        options={deliveryInfoOptions}
        value={
          deliveryInfoOptions?.find((o) => o.value === value?.id) || {
            label: value.name,
            value: value.id,
          }
        }
        onChange={(option) =>
          setFieldValue('deliveryInfo', {
            ...value,
            id: option.value,
            name: option.label,
          })
        }
        isClearable={false}
        isSearchable
      />
    </div>
  );
});

export const DefaultVatSelect = ({ defaultVat, setFieldValue }) => {
  return (
    <div className="col-12 mt-2">
      <Select
        id="defaultVat"
        label="НДС"
        options={VAT_RATES}
        value={VAT_RATES?.find((o) => o.value === defaultVat)}
        onChange={(option) => setFieldValue('defaultVat', option.value)}
        isClearable={false}
      />
    </div>
  );
};

export const AvitoDeliveryContractSelect = React.memo(({ entry, value, handleChange, label }) => {
  const deliveryInfoList = useSelector((state) => state.admin?.deliveryInfo?.deliveryInfoList);

  const deliveryInfoOptions = useMemo(
    () =>
      deliveryInfoList
        ?.filter((item) => item.active)
        ?.map(({ title, code }) => ({
          label: title,
          value: code,
        })),
    [deliveryInfoList],
  );

  return (
    <div className="col-12 mb-2 mr-1 ml-2" style={{ maxWidth: '33%' }}>
      <Select
        options={deliveryInfoOptions}
        value={
          deliveryInfoOptions?.find((o) => o.value === value) || {
            label: value.name,
            value: value.id,
          }
        }
        onChange={({ value }) => handleChange(entry.path, value, entry.type)}
        isClearable={false}
        isSearchable
      />
    </div>
  );
});
